"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/parse`;
    }
    /**
     * Returns one or more parsed and/or formatted phone numbers that are passed as strings.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/number-parser/parse
     * Rate Limit Group: Light
     */
    async post(parsePhoneNumberRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), parsePhoneNumberRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map